import React from 'react';
import CheckboxField from '../../../../Components/Form/components/CheckboxField';
import useElectronicSignature from '../../../Certificates/Hooks/useElectronicSignature';
import ElectronicSignatureUnavailableTooltip from '../ElectronicSignature/ElectronicSignatureUnavailableTooltip';
import Loading from '../../../../Components/Loading';
import ElectronicSignatureTimestampUnavailableTooltip from '../ElectronicSignature/ElectronicSignatureTimestampUnavailableTooltip';

interface Props {
	showElectronicSignatureField?: boolean;
}

const ElectronicSignatureFields: React.FC<Props> = ({
	showElectronicSignatureField = true,
}) => {
	const {
		isQualifiedCertificateForElectronicSignatureUsed,
		isElectronicSignatureTimestampAllowed,
		isLoading,
	} = useElectronicSignature();

	if (isLoading) {
		return <Loading />;
	}

	const electronicSignatureCheckbox = showElectronicSignatureField ? (
		<CheckboxField
			name='electronicSignature'
			tx='component.electronicSignatureFields.electronicSignature'
			isDisabled={!isQualifiedCertificateForElectronicSignatureUsed}
			isWrapped
			isRequired
		/>
	) : (
		<></>
	);

	const electronicSignatureTimestampCheckbox = (
		<CheckboxField
			name='electronicSignatureTimestamp'
			tx='component.electronicSignatureFields.electronicSignatureTimestamp'
			isDisabled={
				!isQualifiedCertificateForElectronicSignatureUsed ||
				!isElectronicSignatureTimestampAllowed
			}
			isWrapped
			isRequired
		/>
	);

	if (!isQualifiedCertificateForElectronicSignatureUsed) {
		return (
			<>
				<ElectronicSignatureUnavailableTooltip
					trigger={electronicSignatureCheckbox}
				/>
				<ElectronicSignatureUnavailableTooltip
					trigger={electronicSignatureTimestampCheckbox}
				/>
			</>
		);
	}

	if (!isElectronicSignatureTimestampAllowed) {
		return (
			<>
				{electronicSignatureCheckbox}
				<ElectronicSignatureTimestampUnavailableTooltip
					trigger={electronicSignatureTimestampCheckbox}
				/>
			</>
		);
	}

	return (
		<>
			{electronicSignatureCheckbox}
			{electronicSignatureTimestampCheckbox}
		</>
	);
};

export default ElectronicSignatureFields;
